import React from "react";

const MiniCardAbout = () => {
  return (
    <div className="container-fluid">
      <div className="card-group col-sm gap-3">
        <div className="card lynx_darkcards">
          <div className="card-body">
            <p className="card-title text-lynx fw-bold">LifeStyle Club</p>
            <small className="card-text text-white d-block">
              Content. Articles. Apps.
            </small>
            <small className="card-text text-white d-block">
              Draws to win aritime and other prizes
            </small>
          </div>
        </div>
        <div className="card lynx_darkcards">
          <div className="card-body">
            <p className="card-title text-lynx fw-bold">Discounts</p>
            <small className="card-text text-white d-block">
              Discounts from our partners
            </small>
          </div>
        </div>
        <div className="card lynx_darkcards">
          <div className="card-body">
            <p className="card-title text-lynx fw-bold">Win Prizes</p>
            <small className="card-text text-white d-block">
              Draws to win airtime and other prizes!
            </small>
          </div>
        </div>
      </div>
      <div className="lynx_darkcards_noborder text-center p-4 my-4">
        <h1 className="display-6 text-lynx fw-bold">✨ Coming soon!</h1>
      </div>
      <div className="card-group col-sm gap-3">
        <div className="card lynx_darkcards">
          <div className="card-body">
            <p className="card-title text-lynx fw-bold">100% Safe Browsing</p>
            <small className="card-text text-white d-block">
              Child Safe internet browser
            </small>
          </div>
        </div>
        <div className="card lynx_darkcards">
          <div className="card-body">
            <p className="card-title text-lynx fw-bold">Secure Family Tracking</p>
            <small className="card-text text-white d-block">
              Keep your loved ones safe! View and Share Family Members location
              -- Press A panic to Alert your family
            </small>
          </div>
        </div>
        <div className="card lynx_darkcards">
          <div className="card-body">
            <p className="card-title text-lynx fw-bold">Business Documents</p>
            <small className="card-text text-white d-block">
              Invoicing. Travel Log. Fuel Efficiency
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCardAbout;
